import ContractsTaxiForwardingContractListParams from "./contracts-taxi-forwarding-contract-list-params";
import ContractsTaxiForwardingContractList from "./contracts-taxi-forwarding-contract-list";
import useAsyncData from "../../../../hooks/use-async-data";
import contractsService from "../../contracts.service";

const useContractsTaxiForwardingContractList = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<ContractsTaxiForwardingContractList>({
      data: [],
      totalCount: 0,
    });

  const load = async (
    params: ContractsTaxiForwardingContractListParams,
    signal: AbortSignal,
  ): Promise<void> => {
    setIsLoading(true);
    setIsError(false);

    try {
      const taxiContractList =
        await contractsService.getTaxiForwardingContractList(params, signal);

      setData(taxiContractList);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    data,
    load,
  };
};

export default useContractsTaxiForwardingContractList;
